import { Alert, Stack, Text } from '@mantine/core'
import { IconInfoCircle } from '@tabler/icons-react'

export function ConsumptionGuidance() {
  return (
    <Alert
      icon={<IconInfoCircle size={20} />}
      title="Aloita kulutusseuranta"
      color="blue"
      variant="light"
    >
      <Stack gap="xs">
        <Text size="sm">
          Seuraa sähkö-, vesi- ja lämmityskulutustasi mittarilukemien avulla.
        </Text>
        <Text size="sm" fw={500}>
          Näin aloitat:
        </Text>
        <Text size="sm" component="ol" ml="md">
          <li>
            Klikkaa "Lisää"-painiketta haluamallasi kortilla (sähkö, vesi tai
            lämmitys)
          </li>
          <li>
            Syötä mittarin nykyinen lukema. Tämä toimii lähtöpisteenä kulutuksen
            laskentaan.
          </li>
          <li>
            Voit lisätä valinnaisen kustannuksen euroina, jos haluat seurata
            myös menojasi
          </li>
          <li>
            Seuraavalla kerralla kulutus lasketaan automaattisesti: uusi lukema
            - edellinen lukema
          </li>
        </Text>
      </Stack>
    </Alert>
  )
}
